import jsPDF from "jspdf";
import logo from "./assets/logo.png";
import { AMIRI_BASE64 } from "./assets/fonts/Amiri-Regular.base64";

const fmt = (v) => (v == null ? "" : String(v));

// تنسيق رقم/مبلغ (1,000 بدل 1000)
const formatMoney = (n) => {
  if (n == null || n === "") return "";
  let num = Number(n);
  if (Number.isNaN(num)) return String(n);

  return new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(num);
};

export default function generateReceiptPdf({ bol, receipt_no, savedReceiptAmount }) {
  // ✅ Landscape
  const doc = new jsPDF("l", "mm", "a4");

  const pageW = doc.internal.pageSize.getWidth();   // ~297
  const pageH = doc.internal.pageSize.getHeight();  // ~210

  const margin = 12;
  const contentW = pageW - margin * 2;
  const contentH = pageH - 25 - 18; // مساحة مريحة فوق/تحت

  // ===== تحميل الخط العربي =====
  doc.addFileToVFS("Amiri-Regular.ttf", AMIRI_BASE64);
  doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");
  doc.setFont("Amiri", "normal");

  // ===== علامة مائية =====
  const watermarkWidth = 120;
  const watermarkHeight = 70;
  const watermarkX = (pageW - watermarkWidth) / 2;
  const watermarkY = (pageH - watermarkHeight) / 2;
  doc.saveGraphicsState();
  doc.setGState(new doc.GState({opacity: 0.08})); // Opacity خفيفة جداً
  doc.addImage(logo, 'PNG', watermarkX, watermarkY, watermarkWidth, watermarkHeight);
  doc.restoreGraphicsState();

  // ===== إطار خارجي =====
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.6);
  doc.roundedRect(margin, 15, contentW, contentH, 3, 3);

  // ===== هيدر: شعار + اسم الشركة (تقريباً مثل الصورة) =====
  const topY = 18;

  // الشعار يمين أعلى (مثل النموذج)
  try {
   // ===== Logo tuning =====
const LOGO_X_OFFSET = 0;     // غيّرها لتحريك اللوقو يمين/يسار
const LOGO_WIDTH = 28 + 38; // ← زِد/أنقص الرقم كما تريد
const LOGO_HEIGHT = 16;     // غيّر الارتفاع لو لزم

doc.addImage(
  logo,
  "PNG",
  margin + 2 + LOGO_X_OFFSET,
  18,
  LOGO_WIDTH,
  LOGO_HEIGHT
);

  } catch (e) {
    // لو اللوجو ما ظهر ما نوقف
    console.error(e);
  }

  

  // خط تحت الهيدر
  doc.setLineWidth(0.4);
  doc.line(margin + 6, topY + 22, pageW - margin - 6, topY + 22);

  // ===== عنوان الإيصال ورقم الإيصال =====
  doc.setFontSize(18);
  doc.text("ايصال استلام مالي", pageW / 2, topY + 30, { align: "center" });
  
  // ===== رقم البوليصة ورقم الإيصال (في المنتصف باللون الأحمر) =====
  const infoY = topY + 42;
  const awbNo = bol.hawb_no || bol.mawb_no || bol.bol_reference || bol.bolReference || "";
  const awbLabel = bol.hawb_no ? "HAWB NO" : "BOL Ref";
  const finalReceiptNo = receipt_no || bol.receipt_no;
  const receiptNoText = finalReceiptNo ? ` | Receipt No: ${finalReceiptNo}` : "";
  
  // حساب المجموع الكلي (ماستر + جميع الهاوسات)
  // الأولوية لـ savedReceiptAmount الممرر من شاشة إعادة الطباعة
  const masterTotal = Number(savedReceiptAmount ?? bol.receipt_amount ?? bol.fees?.total ?? bol.fees ?? 0) || 0;
  const housesTotal = Array.isArray(bol.homes) ? bol.homes.reduce((sum, h) => sum + (Number(h.fees?.total ?? h.fees ?? 0) || 0), 0) : 0;
  const totalAmount = masterTotal + housesTotal;

  const descriptionText = bol.goods_description
    ? bol.goods_description
    : `رسوم بوليصة ${fmt(bol.bol_reference)}`;
  const serviceName = bol.service_name || bol.service_id || "Service";
  const packingName = bol.packing_type || "";
  const buildUpName = bol.build_up_name || "";
  const packageInfo = bol.number_of_packages ? `${fmt(bol.number_of_packages)} قطعة` : "";
  const weightInfo = bol.gross_mass ? `${fmt(bol.gross_mass)} kg` : "";

  const combinedText = `${awbLabel}: ${fmt(awbNo)}${receiptNoText}`;

  doc.setFontSize(14);
  doc.setTextColor(180, 0, 0); // لون أحمر
  doc.text(combinedText, pageW / 2, infoY, { align: "center" });
  doc.setTextColor(0, 0, 0); // إعادة اللون للأسود

  // ===== مربعات العملة (يسار أعلى) =====
  doc.setFontSize(11);
  const curY = topY + 26;

  // SDG
  doc.text("جنيه", margin + 22, curY, { align: "right" });
  doc.text("SDG", margin + 22, curY + 6, { align: "right" });
  doc.rect(margin + 26, curY - 4, 26, 12);

  // USD
  doc.text("دولار", margin + 62, curY, { align: "right" });
  doc.text("USD", margin + 62, curY + 6, { align: "right" });
  doc.rect(margin + 66, curY - 4, 30, 12);

  // ===== التاريخ (يمين) =====
  const today = new Date().toLocaleDateString('en-CA'); // YYYY-MM-DD
  doc.setFontSize(12);
  doc.text(`التاريخ : ${today}`, pageW - margin - 6, topY + 42, {
    align: "right",
  });

  // ===== دالة خط منقط للحقل =====
  const dottedLine = (x1, x2, y) => {
    doc.setLineDashPattern([0.6, 0.6], 0);
    doc.line(x1, y, x2, y);
    doc.setLineDashPattern([], 0);
  };

  // ===== جسم الإيصال =====
  const baseY = topY + 58;

  // استلمنا من
  doc.setFontSize(13);
  doc.text("استلمنا من السيد / السادة : ", pageW - margin - 6, baseY, { align: "right" });
  doc.setFontSize(11);
  doc.text("Receit From:", margin + 8, baseY);

  dottedLine(margin + 85, pageW - margin - 80, baseY + 2);
  doc.setFontSize(12);
  doc.text(fmt(bol.consignee_name || ""), margin + 90, baseY - 1);

  // مبلغ وقدره
  const y2 = baseY + 15;
  doc.setFontSize(13);
  doc.text("مبلغ وقدره : ", pageW - margin - 6, y2, { align: "right" });
  doc.setFontSize(11);
  doc.text("Sum of:", margin + 8, y2);

  dottedLine(margin + 85, pageW - margin - 80, y2 + 2);
  doc.setFontSize(12);
  doc.text(formatMoney(totalAmount), margin + 90, y2 - 1);

  // ===== خيارات الدفع (يمين) =====
  // (تم ترتيبها أفقياً لأن الصفحة Landscape)
  const payY = y2 + 18;

  // Cash
  doc.setFontSize(12);
  doc.text("نقداً", pageW - margin - 18, payY, { align: "right" });
  doc.setFontSize(10);
  doc.text("Cash", pageW - margin - 18, payY + 6, { align: "right" });
  doc.rect(pageW - margin - 14, payY - 4, 9, 9);

  // Cheque
  doc.setFontSize(12);
  doc.text("شيك", pageW - margin - 55, payY, { align: "right" });
  doc.setFontSize(10);
  doc.text("Cheque", pageW - margin - 55, payY + 6, { align: "right" });
  doc.rect(pageW - margin - 51, payY - 4, 9, 9);

  // Cheque No
  doc.setFontSize(12);
  doc.text("رقم الشيك:", pageW - margin - 90, payY, { align: "right" });
  doc.setFontSize(10);
  doc.text("Cheque No", pageW - margin - 90, payY + 6, { align: "right" });
 // ===== Cheque No box tuning =====
const CHEQUE_BOX_SHIFT = 8; // ← عدّل الرقم يدويًا

doc.rect(
  pageW - margin - 145 - CHEQUE_BOX_SHIFT,
  payY - 4,
  45,
  9
);


  // On Bank
  doc.setFontSize(12);
  doc.text("مسحوب على بنك", pageW - margin - 155, payY, { align: "right" });
  doc.setFontSize(10);
  doc.text("On Bank", pageW - margin - 155, payY + 6, { align: "right" });
  dottedLine(pageW - margin - 250, pageW - margin - 170, payY + 8);

  // Cheque date (يسار)
  doc.setFontSize(12);
  doc.text("تاريخ الشيك", margin + 55, payY, { align: "right" });
  doc.setFontSize(10);
  doc.text("Cheque date", margin + 55, payY + 6, { align: "right" });
  dottedLine(margin + 10, margin + 50, payY + 8);

  // وذلك عبارة عن
  const y3 = payY + 18;
  doc.setFontSize(13);
  doc.text("وذلك عبارة عن : ", pageW - margin - 6, y3, { align: "right" });
  doc.setFontSize(11);
  doc.text("Being amount of:", margin + 8, y3);

  dottedLine(margin + 85, pageW - margin - 80, y3 + 2);
  doc.setFontSize(12);
  doc.text(descriptionText, margin + 90, y3 - 1);

  const detailY = y3 + 12;
  doc.setFontSize(10);
  doc.text(`BOL Ref: ${fmt(bol.bol_reference)}`, margin + 8, detailY);
  doc.text(`Service: ${fmt(serviceName)}`, margin + 8, detailY + 6);
  doc.text(`Packing: ${fmt(packingName)}`, margin + 8, detailY + 12);
  doc.text(`Build-up: ${fmt(buildUpName)}`, margin + 8, detailY + 18);
  doc.text(`Packages: ${packageInfo}`, pageW - margin - 10, detailY, { align: "right" });
  doc.text(`Weight: ${weightInfo}`, pageW - margin - 10, detailY + 6, { align: "right" });
  doc.text(`Exporter: ${fmt(bol.exporter_name)}`, pageW - margin - 10, detailY + 12, { align: "right" });

  // خطوط أسفل مثل النموذج
  doc.setLineWidth(0.3);
  doc.line(margin + 10, detailY + 24, pageW - margin - 10, detailY + 24);
  doc.line(margin + 10, detailY + 32, pageW - margin - 10, detailY + 32);

  // ===== تذييل: مربعات المحاسب =====
  const footY = detailY + 40;

  // يمين: اسم المحاسب
  doc.setLineWidth(0.4);
  doc.rect(pageW - margin - 90, footY, 85, 12);
  doc.setFontSize(11);
  doc.text("اسم المحاسب المستلم", pageW - margin - 8, footY + 8, { align: "right" });
  dottedLine(pageW - margin - 88, pageW - margin - 45, footY + 10);

  // يسار: توقيع المحاسب
  doc.rect(margin + 5, footY, 95, 12);
  doc.text("توقيع المحاسب المستلم", margin + 98, footY + 8, { align: "right" });
  dottedLine(margin + 8, margin + 55, footY + 10);

  doc.save(`Receipt_${bol.bol_reference || "001"}.pdf`);
}
